import React from "react";

function GroupIconWhite({ width, height, onClick }) {
  return (
    <svg
      width={width}
      height={height}
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 208 57"
      className="cursor-pointer"
      onClick={onClick}
    >
      <path
        fill="#fff"
        d="M67.455 0v56.197h-9.473V0h9.473zm-3.854 0h11.722c4.12 0 7.68.723 10.678 2.167 2.996 1.446 5.338 3.466 7.024 6.062 1.686 2.597 2.529 5.66 2.529 9.192s-.843 6.611-2.53 9.232c-1.685 2.623-4.027 4.657-7.023 6.102-2.999 1.445-6.558 2.167-10.678 2.167H63.601v-7.867h11.32c2.194 0 4.095-.361 5.7-1.084 1.606-.722 2.863-1.793 3.774-3.21.909-1.418 1.365-3.119 1.365-5.1 0-2.033-.456-3.745-1.365-5.137-.91-1.391-2.168-2.461-3.774-3.211-1.605-.75-3.506-1.124-5.7-1.124h-11.32V0zM79.82 29.383l19.107 26.814h-11.48L69.622 29.383h10.196zM111.168 54.592c-2.863-1.606-5.071-3.854-6.623-6.744-1.552-2.89-2.328-6.262-2.328-10.115 0-3.906.789-7.306 2.368-10.197 1.578-2.89 3.814-5.124 6.704-6.703 2.89-1.578 6.289-2.368 10.196-2.368 3.906 0 7.238.75 9.995 2.248 2.756 1.498 4.857 3.652 6.302 6.463 1.445 2.809 2.167 6.195 2.167 10.155 0 .43-.013.883-.039 1.365-.028.482-.041.83-.041 1.044h-32.434v-6.021h24.968l-2.649 3.692c.16-.32.334-.748.522-1.284.186-.534.281-.99.281-1.365 0-1.98-.389-3.692-1.165-5.138-.776-1.445-1.846-2.569-3.21-3.372-1.365-.802-2.959-1.204-4.777-1.204-2.196 0-4.054.482-5.58 1.445-1.526.963-2.703 2.356-3.532 4.175-.831 1.82-1.245 4.068-1.245 6.743-.054 2.623.334 4.872 1.164 6.745.83 1.873 2.02 3.291 3.573 4.254 1.551.964 3.452 1.446 5.7 1.446 2.409 0 4.496-.482 6.262-1.446 1.766-.963 3.211-2.435 4.335-4.415l7.546 2.97c-1.98 3.32-4.495 5.82-7.546 7.507-3.051 1.685-6.717 2.528-10.999 2.528-3.747 0-7.052-.803-9.915-2.408zM170.375 27.536c-1.124-1.39-2.838-2.087-5.139-2.087-1.659 0-3.104.336-4.334 1.004a6.912 6.912 0 00-2.851 2.89c-.669 1.258-1.003 2.718-1.003 4.376v22.478h-8.751v-36.93h8.751v5.7c1.176-2.193 2.689-3.825 4.536-4.897 1.846-1.07 4.026-1.605 6.543-1.605 4.175 0 7.358 1.272 9.553 3.814 2.194 2.542 3.292 6.008 3.292 10.396v23.522h-8.911V33.72c0-2.73-.562-4.79-1.686-6.183zM207.865 19.267v7.627h-20.953v-7.627h20.953zm-6.182-12.845v49.774h-8.51V6.422h8.51z"
      ></path>
      <path
        fill="url(#paint0_linear_92_106)"
        d="M22.228 0c-1.661 5.392-4.037 8.938-5.847 11.136-1.365 1.658-3.071 3.295-6.482 6.568a241.685 241.685 0 01-5.466 5.084c-.387.33-5.166 4.564-4.337 10.847.107.803.829 5.612 5.205 8.222 5.345 3.188 11.03.046 11.353-.14 3.573-2.056 4.901-5.423 5.256-6.43.168 1.221.828 6.993-3.071 12.246-4.841 6.52-12.59 6.69-13.474 6.694a1.551 1.551 0 00-.747.595c-.369.566-.213 1.171-.185 1.27h35.506c.025-.074.205-.63-.127-1.145a1.31 1.31 0 00-.676-.52c-1.008.022-7.33.05-12.078-5.03-5.484-5.869-4.09-13.446-3.94-14.194 1.794 5.1 6.35 8.405 11.143 8.304 3.04-.064 6.335-1.571 8.39-4.448.373-.523 2.415-3.486 1.892-7.239-.32-2.296-1.705-4.07-4.465-7.52-1.775-2.22-3.23-3.753-4.72-5.312-3.099-3.246-5.152-4.98-8.075-8.833-.21-.275-.362-.473-.564-.756C25.351 7.481 23.522 4.424 22.23 0z"
      ></path>
      <path
        fill="url(#paint1_linear_92_106)"
        d="M23.118 35.203c.09.273 2.38 6.81 8.698 8.06.643.127 4.653.853 8.297-1.702 2.662-1.867 3.651-4.449 3.906-5.144.236-.639.647-1.79.625-3.305-.032-2.202-.962-3.862-1.502-4.75-2.735-4.491-7.382-8.696-11.785-13.455-3.995-4.32-5.283-6.386-5.881-7.404A33.685 33.685 0 0122.228 0c-2.132 8.3-.968 13.766.546 17.264 1.588 3.667 4.063 6.328 3.755 10.553-.236 3.246-1.996 5.778-3.411 7.386z"
      ></path>
      <path
        fill="url(#paint2_linear_92_106)"
        d="M21.91 35.288c.242 1.6.591 5.43-1.38 9.544-2.49 5.201-7.04 7.416-8.884 8.16a17.216 17.216 0 01-6.282 1.236c-.153.055-.337.15-.505.311-.584.563-.446 1.442-.427 1.553h35.525c.026-.08.179-.571-.1-1.066a1.342 1.342 0 00-.722-.598c-1.073.018-7.115.022-11.796-4.749-5.755-5.867-4.36-13.763-4.221-14.476l-1.208.085z"
        opacity="0.87"
      ></path>
      <defs>
        <linearGradient
          id="paint0_linear_92_106"
          x1="44.629"
          x2="0"
          y1="28.046"
          y2="28.046"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#124D95"></stop>
          <stop offset="0.586" stopColor="#156FB8"></stop>
          <stop offset="1" stopColor="#2086C8"></stop>
        </linearGradient>
        <linearGradient
          id="paint1_linear_92_106"
          x1="44.645"
          x2="21.063"
          y1="21.727"
          y2="21.727"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF9A66"></stop>
          <stop offset="1" stopColor="#F0E620"></stop>
        </linearGradient>
        <linearGradient
          id="paint2_linear_92_106"
          x1="40.022"
          x2="4.404"
          y1="45.647"
          y2="45.647"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00C8CD"></stop>
          <stop offset="1" stopColor="#31727C"></stop>
        </linearGradient>
      </defs>
    </svg>
  );
}

export default GroupIconWhite;
